// extracted by mini-css-extract-plugin
export default {"app":"App_app__qeOtt","app__header":"App_app__header__h9sR3"};